import PostContent from "../types/post-type";
import api from "./auth-interceptor";

class PostService {
  getPrivatePosts() {
    return api.get<PostContent[]>(`posts/private`);
  }

  getPublicPosts() {
    return api.get<PostContent[]>(`posts/public`);
  }

  getInfoById(postId: string, visibility: 'public' | 'private' | undefined) {
    return api.get<PostContent>(`posts/${visibility}/${postId}`);
}

  createPost(postContent: PostContent) {
    return api.post(`posts/`, postContent);
  }

  updatePost(postId: string, visibility: string, postContent: PostContent) {
    return api.put(`posts/${visibility}/${postId}`, postContent);
  }

  deletePost(postId: string, visibility: string) {
    return api.delete<PostContent[]>(`posts/${visibility}/${postId}`);
  }
}

const postService = new PostService();
export default postService;
